
































































import AirlineCompany from "@/store/entities/flight/airlineCompany";
import { Component, Vue } from "vue-property-decorator";
@Component({})
export default class AddCompany extends Vue {
  isEdit: boolean = false;
  isValid: boolean = false;
  dialog: boolean = true;
  airlineCompany: AirlineCompany = new AirlineCompany();

  data() {
    return {
      title: "Preliminary report",
      email: "",
      rules: {
        required: (value) => !!value || "Zorunlu Alan.",
      },
    };
  }

  created() {
    this.airlineCompany = this.$store.state.airlineCompany.editAirlineCompany;
    if (this.airlineCompany == null) {
      this.isEdit = false;
      this.airlineCompany = new AirlineCompany();
      this.airlineCompany.companyType = 1;
    } else {
      this.isEdit = true;
    }
  }

  async saveAirlineCompany() {
    this.airlineCompany.companyType = 1;
    this.airlineCompany.type = 1;
    if (!this.isEdit) {
      await this.$store.dispatch({
        type: "airlineCompany/saveAirlineCompany",
        data: this.airlineCompany,
      });

      Vue.$toast.success("Kayıt Eklendi");
      this.closeDialog();
    } else {
      await this.$store.dispatch({
        type: "airlineCompany/saveAirlineCompany",
        data: this.airlineCompany,
      });

      Vue.$toast.success("Kayıt Güncellendi");

      this.closeDialog();
    }
  }

  closeDialog() {
    this.$emit("closed");
  }

  cancelDialog() {
    this.$emit("cancel");
    this.$store.state.airlineCompany.editAirlineCompany = null;
  }
}
